import React from "react";
import { BsInstagram, BsTwitter, BsLinkedin, BsGithub } from "react-icons/bs";
import Mapsetup from "./Mapsetup";
import { NavLink } from "react-router-dom";

/* Footer */

export default function Footer() {
  const scrollup = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="bg-gray-800  text-gray-300">

      {/* social media handles */}
      <div className="text-center w-full p-5">
        <span className="sm:inline hidden text-lg">Follow us on :</span>
        {/* <span className=" p-2 text-xl">
          <a href="">
            <BsFacebook className=" inline" />
          </a>
        </span> */}
        <span className=" p-2 text-xl">
          <a href="https://www.instagram.com/acm_vnrvjiet">
            <BsInstagram className=" inline" />
          </a>
        </span>
        <span className=" p-2 text-xl">
          {" "}
          <a href="https://github.com/acmvnrvjiet">
            <BsGithub className=" inline" />
          </a>
        </span>
        <span className=" p-2 text-xl">
          {" "}
          <a href="https://www.linkedin.com/company/acm-vnrvjiet/">
            <BsLinkedin className=" inline" />
          </a>
        </span>
      </div>
      {/* <div className="flex justify-center w-full">
        <div className="w-[85vw] h-[1px] bg-gray-400"></div>
      </div> */}

      {/* copy rights */}
      <div className="text-center w-full p-5">
        ©  ACM VNRVJIET, Inc. All rights reserved.
      </div>
    </div>
  );
}
